<template>
  <div class="safe">
    <div class="header">
    	<div class="header-layout">
    		<h1 class="logo" id="logo">
    			<a href="http://www.ddzzii.com"></a>
    		</h1>
    		<a class="logo-title"> 验证身份 </a>
    		<ul class="header-nav" v-if="this.$cookies.isKey('token') === false">
    			<li class="li-first">
    				<a href="">注册</a>
    			</li>
    			<li>
    				<a href="">登录</a>
    			</li>
    			<li>
    				<a href="/index">首页</a>
    			</li>
    			<li>
    				<a href="">帮助中心</a>
    			</li>
    		</ul>
			<ul class="header-nav" v-if="this.$cookies.isKey('token')">
				<li class="li-first">
					<div>您好，{{$store.state.username}}</div>
				</li>
				<li>
					<a class="logout" @click="$api.user.logout()">退出</a>
				</li>
				<li>
					<a href="/index">首页</a>
				</li>
				<li>
					<a href="">帮助中心</a>
				</li>
			</ul>
    	</div>
    </div>
	<div class="content">
	<div>
		<el-dialog :visible="visibleDialog" title="验证手机" width="480px" @opened="dialogOpenHandler"
	           @close="dialogCloseHandler" :close-on-click-modal="false" :close-on-press-escape="false">
			<el-row type="flex" class="row-bg dialog-row" style="height: 40px;line-height: 40px;" justify="center"
	          :gutter="5">
				<el-col :span="4">校验码：</el-col>
				<verify-image v-model="refreshCode" @blur="verifyCode" :form-key="formKey"
	                  @change="code=$event"></verify-image>
			</el-row>
			<div class="dialogButton submitButton">
				<el-button type="primary" @click="GetCaptcha">提交</el-button>
			</div>
		</el-dialog>
	</div>
	<div class="maincenter">
	<div>
		<el-steps :active="step" align-center process-status="finish" finish-status="success" class="authc-steps">
			<el-step title="验证身份"></el-step>
			<el-step :title="ivActionType"></el-step>
			<el-step title="完成"></el-step>
		</el-steps>
	</div>
	<div class="maincenter-box">
		<div style="width: 80%;margin:0 auto;font-size: 14px;border-bottom: 1px solid #b9b9b9;">手机验证码验证&nbsp;&nbsp;账号<span style="color: #00B7D3;">{{$store.state.username}}</span>为确认是你本人操作，请完成以下验证</div>
		<div class="form">
			<div class="form-phone">
			  <div class="form-phone-item form-item-L">手机号码 :</div>
			  <div class="form-phone-item form-item-M">
				{{ $store.state.username }}
			  </div>
			  <div class="form-phone-item form-item-R">
				<span>[手机不可用？点此修改]</span>
			  </div>
			  <div class=""></div>
			</div>
			<div class="form-phone">
			  <div class="form-phone-item form-item-L">验证码 :</div>
			  <div class="form-phone-item form-item-M">
				<!-- <el-input v-model.trim="formData.name" placeholder="请输入验证码" class="form-input"></el-input> -->
				<el-input v-model.trim="phoneCode" maxlength="6" placeholder="请输入验证码" class="form-input"></el-input>
			  </div>
			  <!-- <el-button type="primary" style="width: 240px;" @click="beforGetCaptcha">获取短信验证码</el-button> -->
			  <div class="form-phone-item form-item-R">
				<count-down-button ref="resendCDBtn" type="primary" :time="60" @click="beforGetCaptcha" style="width: 240px;"
					:click-start="flag">
					{{GetCaptchaButton}}
				</count-down-button>
			  </div>
			  <div class="form-phone-item error-info">{{ errors.name }}</div>
			</div>
			<div class="form-phone">
			  <div class="form-phone-item form-item-M submitButton">
				<el-button type="primary" @click="submitHandler">确认</el-button>
			  </div>
			  <div class="form-phone-item form-item-R">
			  	<span>其他验证方式</span>
			  </div>
			</div>
		</div>
	</div>
	</div>
	<div class="bottom-tips">
		<div class="err-solution">
			<div class="err-solution-title">没收到短信验证码？</div>
			<div class="err-solution-content">1、网络通讯异常可能会造成短信丢失，请重新获取或稍后再试。</div>
			<div class="err-solution-content">2、请核实手机是否已欠费、或者屏蔽了系统短信。</div>
			<div class="err-solution-content">3、如果手机已丢失或停用，请选择其他验证方式。</div>
			<div class="err-solution-content">4、您也可以尝试SIM卡移动到另一部手机，然后重试。</div>
		</div>
	</div>
	</div>
	<footer-layout></footer-layout>
  </div>
</template>

<script>
  import VerifyImage from '@/components/fields/VerifyImage'
  import CountDownButton from '@/components/fields/CountDownButton'
  import FooterLayout from '@/components/layout/FooterLayout'
  export default {
    name: 'VerifyPhone',
    components: {FooterLayout,VerifyImage,CountDownButton},
    data() {
      return {
		ivActionType: '',
		phone: '',
		step: 0,
		phoneCode: '',
		code: '',
		GetCaptchaButton: '获取短信验证码',
		formKey: '',
        industries: [],
		visibleDialog: false,
		refreshCode: false,
		errmsg: [],
		flag: false,
        errors: {
          name: '',
          idcard: '',
          addr: '',
          industry: '',
        },
        formData: {
          name: '',
          idcard: '',
          addr: '',
          industry: '',
        },
		asyncCodeVerify: false
      }
    },
	watch: {
	  code(nv, ov) {
	    if (nv.length === 6) {
	      this.verifyCode()
	    }
	  },
	},
    methods: {
	  /**
	   * 手机号码确认框打开事件
	   */
	  dialogOpenHandler() {
	    // this.$refs.resendCDBtn.start()
	  },
	  /**
	   * 手机号码确认框关闭事件
	   */
	  dialogCloseHandler() {
	    this.visibleDialog = false
	  },
	  /**
	   * 验证验证码
	   */
	  verifyCode() {
	    this.asyncCodeVerify = false
	    if (this.code.length === 6) {
	      this.$api.common.verifyImgCode(this.formKey, this.code).then(res => {
	        if (res.data === true) {
	          // this.$set(this.errmsg, 'code', '')
	          this.asyncCodeVerify = true
	        } else {
	          // this.$set(this.errmsg, 'code', '验证码错误，请重新输入')
	          // 刷新验证码
	          this.refreshCode = true
	          this.asyncCodeVerify = false
	        }
	      })
	    } else {
	      // this.$set(this.errmsg, 'code', '验证码错误，请重新输入')
	    }
	  },
      submitHandler() {
		if ( this.phoneCode.length === 6 ) {
			// this.$router.push({path:'/reset_password'})
        this.$api.user.safetycode(this.formKey, this.phoneCode, this.phone).then(res => {
        	console.log(res)
          // 1030 formKey过期 1012 验证码错误
          if (res.code === 0) {
			  switch (this.ivActionType) {
			  	case ('找回密码') :
			  		this.$router.push({path:'/findpassword', query: { safety: res.data }})
					break
			  	case ('修改密码') :
			  		this.$router.push({path:'/reset_password', query: { safety: res.data }})
					break
				case ('修改安全邮箱') :
					this.$router.push({path:'/bindmail', query: { safety: res.data }})
					break
			  }
          } else {
            let msg = res.msg
            if (res.details) {
              msg += ',' + res.details
            }
            this.$message.error(msg)
          }
        })
		}
		
		
        // 提交
      },
	  // 点击获取短信验证码按键
	  beforGetCaptcha () {
		if ( this.flag === false ) {
			this.visibleDialog = true
			this.$api.common.formKey().then(res => {
			  console.log(res)
			  if (res.code === 0) {
			    this.formKey = res.data
			  } else {
				  let msg = res.msg
				  if (res.details) {
				    msg += ',' + res.details
				  }
				  this.$message.error(msg)
			  }
			})
		} else {
			this.$api.common.sendSms(this.phone, this.formKey, this.code, true).then(res => {
				console.log(res)
			  // 1130 formKey过期 1012 验证码错误
			  if (res.code === 0) {
				  return
			  } else if (res.code === 1130) {
			    let msg = res.msg
				this.flag = false
			    if (res.details) {
			      msg += ',' + res.details
			    }
			    this.$message.error(msg)
			  } else {
				  let msg = res.msg
				  if (res.details) {
				    msg += ',' + res.details
				  }
				  this.$message.error(msg)
			  }
			})
		}
	  },
	  // 点击提交验证码按键
	  GetCaptcha () {
		if (this.asyncCodeVerify) {
			this.visibleDialog = false
			this.$refs.resendCDBtn.start()
			this.$api.common.sendSms(this.phone, this.formKey, this.code, false).then(res => {
				console.log(res)
				this.flag = true
				this.GetCaptchaButton = '重新获取'
				if (res.code === 0) {
				} else {
				  let msg = res.msg
				  if (res.details) {
				    msg += ',' + res.details
				  }
				  this.$message.error(msg)
				}
			})
		} else {
			return
		}
	  }
    },
    created() {
		console.log(this.$cookies.isKey('token'))
		this.phone = this.$route.params.phone
		if (this.$route.params.phone !== undefined) {
			this.$store.state.username = this.$route.params.phone
		}
		if (this.$route.params.phone == undefined && this.$store.state.username == null){
			this.$router.push({name:'CheckPhone'})
		}
		this.ivActionType = window.localStorage.getItem('ivActionType')
		console.log(this.ivActionType)
		switch (this.ivActionType) {
			case ('password_reset') :
				this.ivActionType = '找回密码'
				break
			case ('password_modify') :
				this.ivActionType = '修改密码'
				break
			case ('help_email_modify') :
				this.ivActionType = '修改安全邮箱'
				break
		}
    }
  }
</script>

<style>
.form-input .el-input__inner{
	padding: 10px 5px;
	border-radius: 0px;
	height: 36px;
	font-size: 12px;
}
</style>

<style scoped>
  .authc-steps {
    margin-top: 40px;
	margin-bottom: 30px;
  }
  .safe .content{
  	width: 990px;
  	/* height: 1050px; */
  	margin: 0 auto;
	font-size: 12px;
  }
  .maincenter-box .form{
  	padding: 0px 5px 20px 120px;
  }
  .maincenter-box {
	margin: 0 auto;
	padding: 20px 0;
	width: 774px;
	height: auto;
  }
  .form-item-L {
	  width: 70px;
	  margin-right: 20px;
	  text-align: right;
	  font-size: 14px;
  }
  .form-item-M {
	  
  }
  .form-item-M .el-button{
	  width: 150px;
	  /* line-height: 18px; */
	  font-size: 12px;
	  border-radius: 2px;
	  margin-left: 90px;
  }
  .form-item-R .el-button{
	  border: 1px solid #FF751A;
  	  background-color: #FFF1E8;
  	  color: #FF751A;
  }
  .form-item-R span{
	  color: #9B9EA0;
	  cursor: pointer;
  }
  .form-item-R:hover span{
  	  color: #02b2f8;
  }
  .bottom-tips {
	  margin: 0 auto;
	  width: 774px;
	  height: auto;
  }
  .err-solution {
	  text-align: left;
	  border: 1px solid #f9efd3;
	  background-color: #fffbed;
	  padding: 30px 30px 15px;
  }
  
  .err-solution-title {
	  margin-bottom: 20px;
	  font-weight: bold;
	  font-size: 18px;
  }
  
  .err-solution-content {
	  margin: 12px 0;
	  letter-spacing: 2px;
	  color: #737373;
  }
  
  .form-divider{
	  margin: 10px 0 30px 0;
  }
  
  .form-input{
	  /* font-size: 12px; */
	  width: 110px;
  }
  .form-hint {
    padding: 5px 0;
    margin-bottom: 20px;
    border: 1px solid #eee;
    background: #eee;
    text-align: center;
    color: #666;
    border-radius: 2px;
  }

  .error-info {
    color: red;
  }
  
  .form-phone {
	  height: 56px;
  }
  .form-phone-item{
	  line-height: 36px;
	  float: left;
  }
  .form-phone-item .el-button{
	  height: 36px;
	  /* line-height: 18px; */
	  font-size: 12px;
	  border-radius: 2px;
  }
  .footer {
	 text-align: center;
	 width: 120px;
	 margin: 30px auto;
  }
  .dialogButton{
	  width: 150px;
	  margin: 0 auto;
	  margin-top: 36px;
  }
</style>
